import { createSlice } from "@reduxjs/toolkit";
import { UploadImg } from "../services/uploadImg";


let initialState = {
  isLoading: false,
  data: [],
  pages: 0,
  errors: null,
};


const UploadImgSlice = createSlice({
  name: "UploadImg",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(UploadImg.pending, (state) => {
      state.isLoading = true;
      state.errors = null;
    });
    builder.addCase(UploadImg.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.data = payload;
      state.errors = null;
    });
    builder.addCase(UploadImg.rejected, (state) => {
      state.isLoading = false;
      state.errors = [{ msg: "something went wrong!" }];
    });
  },
});

export default UploadImgSlice.reducer;